
function Footer() {
    return (
        <footer className="flex justify-end">
              Footer...
        </footer>
    );
  }
  
  export default Footer;
  